<template>
    <div class="schedule-tab">

        <div class="title body-item"></div>

        <div class="tab-hd">

            <div class="u-btn" :class="[{act : now == 0}]" @click="now=0">线上选拔赛</div>
            <div class="u-btn">
                城市选拔赛
                <div class="image-preview" v-if="config.tab_bd.length >= 2 && config.tab_bd[1].length">                           
                    <el-image 
                        style="width: 100%; height: 100%"
                        :src="config.tab_bd[1][0].image"
                        :preview-src-list="[config.tab_bd[1][0].image]" 
                    >
                    </el-image>
                </div>                 
            </div>
        </div>

        <div class="tab-view">
            <div class="tab-container" v-if="ready && now == 0">               
                <ul v-if="config.tab_bd[now] && config.tab_bd[now].length">
                    <li class="s-item" v-for="(item,index) in config.tab_bd[now]" :key="index">
                        <p>{{ crtTimeFtt(item.startTime) }}线上选拔赛</p>
                        <!-- <p>{{ item.group }}</p> -->
                        <div class="image-preview">                           
                            <el-image 
                                style="width: 100%; height: 100%"
                                :src="require('../assets/images/sample.png')" 
                                :preview-src-list="[item.image]">
                            </el-image>
                        </div>                    
                    </li>
                </ul>
                
                <div class="tbc" v-else></div>
            </div>

        </div>

        <div class="all-sche-img"></div>

        <sponsor></sponsor>
    </div>
</template>

<style scoped>


    .schedule-tab{
        width: 100%;
        /* height: 1659px; */
        height: 1558px;
        margin: 0 auto;
        padding-top: 40px;
        background-image: url(~@/assets/images/bg-others.jpg); 
        background-position: bottom center;
        background-repeat: no-repeat;
        box-sizing: border-box;          
    }

    .title{
        width: 1113px;
        height: 170px;
        margin: 0 auto;
        background-image: url(~@/assets/images/title-5.png);
    }


    .tab-hd{
        display: flex;
        justify-content: space-between;
        /* padding: 0 45px; */
        width: 1388px;
        height: 57px;
        margin: 45px auto 0;
        /* background-image: url(~@/assets/images/faker.png); */
        box-sizing: border-box;
        border: 1px solid #b28850;
    }

    .tab-hd .u-btn{
        position: relative;
        width: 50%;
        height: 55px;
        line-height: 55px;
        font-size: 28px;
        text-align: center;       
        color: #ffe0ba;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url(~@/assets/images/btn-tab_normal.png);
    }

    .u-btn .image-preview{
        z-index: 3;
    }

    .tab-hd .u-btn.act{
        color: #653715;
        background-image: url(~@/assets/images/btn-tab.png);
    }
    
    .tab-container{
        position: relative;
        width: 1387px;
        height: 400px;
        margin: 20px auto 0;
        background-image: url(~@/assets/images/bg-com.png);
    }

    .tab-view ul{
        display: flex;
        flex-wrap: wrap;
        padding-top: 58px;
        padding: 54px 75px 0;
    }

    .s-item{
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 276px;
        height: 75px;
        padding: 5px 0;
        margin: 0 15px 35px;
        background-image: url(../assets/images/com-item.png);
        font-size: 20px;
        color: #b28850;
        box-sizing: border-box;
    }

    .s-item:hover{
        color: #ffe0ba;
        background-image: url(../assets/images/com-item_act.png);
    }

    .s-item p{
        width: 100%;
        text-align: center;
        font-size: 24px;
        font-family: 'pageFont_SYH_BOLD';
    }

    .image-preview{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
    }

    .tab-view .tbc{
        position: absolute;
        width: 197px;
        height: 46px;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        background-image: url(../assets/images/icon-tbc.png);
    }
</style>

<script>
import sponsor from '@/components/sponsor.vue'
import vuescroll from 'vuescroll';

export default {
    data (){
        return {
            config : {
                tab_hd : ['线上选拔赛赛程','城市选拔赛赛程'],
                tab_bd : [],
            },
            now : 0,
            tag : ['线上选拔赛','城市选拔赛'],
            ready : false,
            ops: {
                rail: {
                    opacity: 1,
                    background : '#000',
                },
                bar: {
                    background: '#b28850',
                    keepShow : true,
                }
            },                         
        }
    },
    components : {
        'sponsor' : sponsor,
        vuescroll,
    },    
    created (){
        this.get_schedule_info();
        console.log(this.config.tab_bd[this.now]);
    },
    methods : {
        get_schedule_info (){
            var _this = this;
            this.$axios.get(this.$ajax_url_map.matchlist)
            .then(res => {
                if(res.data.code == this.$ajax_code.success){
                    _this.ready = true;
                    for(var i = 0;i < _this.config.tab_hd.length;i++){
                        var temp = res.data.data.filter(function(e){
                            return e.period == _this.tag[i];
                        });
                        
                        _this.config.tab_bd[i] = temp.length ? temp[0].groups : [];
                    }
                }
                else{
                    this.$message.error('赛程模块：数据请求失败，请稍后再试');
                }
            });
        },
        dateFtt(fmt,date){
            var o = { 
                "M+" : date.getMonth()+1,     //月份 
                "d+" : date.getDate(),     //日 
                "h+" : date.getHours(),     //小时 
                "m+" : date.getMinutes(),     //分 
                "s+" : date.getSeconds(),     //秒 
                "q+" : Math.floor((date.getMonth()+3)/3), //季度 
                "S" : date.getMilliseconds()    //毫秒 
            }; 
            if(/(y+)/.test(fmt)) 
            fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length)); 
            for(var k in o) 
            if(new RegExp("("+ k +")").test(fmt)) 
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length))); 
            return fmt;             
        },
        crtTimeFtt(value,row,index){
            var crtTime = new Date(value);
            return this.dateFtt("MM月dd日",crtTime);//直接调用公共JS里面的时间类处理的办法             
        },        
    },
}
</script>


// WEBPACK FOOTER //
// src/components/scheduleTab.vue